import JsonMapperModuleResolver from "../helpers/JsonMapperModuleResolver";
import InvoiceStripeData from "./InvoiceStripeData";
import GatewayData from "./GatewayData";
export default class GatewayJsonMapperModuleResolver extends JsonMapperModuleResolver {
  static getResolvedModule(data) {
    let module = null;
    switch (data === null || data === void 0 ? void 0 : data.type) {
      case GatewayData.STRIPE_INVOICE:
        module = InvoiceStripeData;
    }
    return module;
  }
}